import axios from "axios";
import { setPayload } from "./api";
import { DATA_SAVE_URL } from "../scenes/utils/UrlHandle";

// services/notificationApiService.js
const API_BASE_URL = DATA_SAVE_URL + "/api";

class NotificationApiService {
  async getAllNotifications(unreadOnly = false) {
    const url = unreadOnly
      ? `${API_BASE_URL}/notifications?unreadOnly=true`
      : `${API_BASE_URL}/notifications`;

    const response = await fetch(url);
    if (!response.ok) {
      throw new Error("Failed to fetch notifications");
    }
    return await response.json();
  }

  async markAsRead(notificationId) {
    // const response = await fetsch(
    //   `${API_BASE_URL}/notifications/${notificationId}/read`,
    //   {
    //     method: "PUT",
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //   }
    // );

    // if (!response.ok) {
    //   throw new Error("Failed to mark notification as read");
    // }

    console.log("not id ", notificationId);

    // await axios
    //   .put(`${API_BASE_URL}/notifications/${notificationId}/read`)
    //   .then(function (response) {
    //     console.log(response.data);
    //   })
    //   .catch(function (error) {
    //     console.log(error);
    //   });

    await setPayload.setPayloadData(
      `${API_BASE_URL}/notifications/${notificationId}/read`
    );
  }

  async markAllAsRead() {
    const response = await fetch(`${API_BASE_URL}/notifications/read-all`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to mark all notifications as read");
    }
  }
}

export default new NotificationApiService();
